import { Stroke, Style } from "ol/style";
import { extractTags } from "./propertyExtraction";
import {
  getLaneDirectionArrowStyles,
  LANE_TYPES,
} from "./util/laneDirectionArrows";

export function getHDMapStyleNormal(feature, resolution) {
  return getHDMapColorStyle(feature, false, false, resolution);
}
export function getHDMapStyleClick(feature, resolution) {
  return getHDMapColorStyle(feature, true, false, resolution);
}
export function getHDMapStyleHover(feature, resolution) {
  return getHDMapColorStyle(feature, false, true, resolution);
}
function getHDMapColorStyle(feature, click, hover, resolution) {
  let color, width, backgroundColor, backgroundWidth;

  const tags = extractTags(feature);
  let hdmapType = tags.hdMap;

  if (hdmapType !== undefined) {
    if (
      hdmapType !== "lane_center_line" &&
      hdmapType !== "lane_trajectory_line"
    ) {
      return;
    }
  }

  let type = feature.get("type");
  if (type === "ORBIS_RELATION") {
    return;
  }

  if (hdmapType === "lane_center_line") {
    color = "blue";
  } else if (hdmapType === "lane_trajectory_line") {
    color = "red";
  } else {
    color = "lightgreen";
  }

  backgroundColor = "white";
  width = 2;
  backgroundWidth = 4;

  const arrows = LANE_TYPES.includes(hdmapType)
    ? getLaneDirectionArrowStyles(
        feature,
        tags.laneDirection,
        "black",
        resolution,
      )
    : [];

  if (hover || click) {
    return [
      new Style({
        stroke: new Stroke({
          color: color,
          width: width,
        }),
      }),
      new Style({
        stroke: new Stroke({
          color: backgroundColor,
          width: backgroundWidth,
        }),
      }),
      ...arrows,
    ];
  }
  return [
    new Style({
      stroke: new Stroke({
        color: color,
        width: width,
      }),
    }),
    ...arrows,
  ];
}
